// extracted by mini-css-extract-plugin
export default {"overlay-container":"styles__overlay-container___m8xlc","overlay-image":"styles__overlay-image___uuzi4"};